




























import Vue from 'vue'
import AppDialog from '~/components/AppDialog.vue'

export default Vue.extend({
  components: {
    AppDialog,
  },
  props: ['trial', 'user'],
  data: () => ({
    email: '',
    center: { id: '', name: '' },
  }),
  methods: {
    isEmailValid(email: string) {
      return !email || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    },
    async handleSend() {
      let payload = {
        email: this.email,
        trial: this.trial,
        center: this.center,
        recievingUser: undefined,
        sendingUser: this.user,
      }

      try {
        let user: any = await this.$axios.get(
          `/user/findByEmail?username=${this.email}`
        )
        if (user.data) {
          user = user.data;
          //verify if the user is part of the trial
          if (user.allowedTrials) {
            for (let i = 0; i < user.allowedTrials.length; i++) {
              const trialId = user.allowedTrials[i].clinicalTrial.id
              if (trialId == this.trial.id) {
                throw new Error(
                  'E-mail has already been added to selected trial.'
                )
              }
            }
            payload.recievingUser = user
          }
          // add the user to the center if the user is not already in the center
          const userCenter = user.centers?.find(
            (center: any) => center.id === this.center.id
          )
          if (!userCenter) {
            await this.$axios.put(
              `/center/addUserToCenter/${this.center.id}?appUserId=${user.id}`
            )
          }
        }
        // send invite email
        const res = await this.$axios.post(`user-invite/`, payload)
        if (res.data.success) {
          this.$toast.success(res.data.msg)
        } else {
          this.$toast.info(res.data.msg)
        }
        this.email = ''
        this.$emit('added')
      } catch (e) {
        if (e.response) {
          this.$toast.error(e.response.data.message)
        } else {
          this.$toast.error(e)
        }
      }
    },
  },
})
